module.exports = __webpack_public_path__ + "static/media/cloud-download-alt.e31e7785.svg";